import * as React from 'react';
import VideoStream from 'components/VideoStream';
import { Video } from 'components/Video';
import { myCameraStream } from 'state/video';
import ParticipantVideo from 'components/ParticipantVideo';
import useVoipConnections from './useVoipConnections';
import { useWebComponent } from 'components/WebComponentRoot';
import SessionControls from 'components/SessionControls';
import EndSessionButton from 'components/EndSessionButton';
import { MultiVoipProps } from './MultiVoip';

type MultiVoipInternalProps = MultiVoipProps & {
  onEndSession?: () => void;
};

export const MultiVoipInternal: React.FC<MultiVoipInternalProps> = ({ onEndSession, controls, className }) => {
  const wcContext = useWebComponent();
  const showControls = wcContext?.controls !== undefined || controls;
  const { canShowVoip, remoteConnections } = useVoipConnections();
  const elementRef = React.useRef<HTMLDivElement>(null);

  return (
    canShowVoip && (
      <div className={className} ref={elementRef}>
        {showControls && (
          <div className="ex3d-stream--voip-controls">
            <SessionControls voipActive>
              <EndSessionButton onEndSession={onEndSession} />
            </SessionControls>
          </div>
        )}
        <div className="ex3d-stream-videos" part="videos">
          {myCameraStream().get('mediaAllowed') && (
            <ParticipantVideo
              audioMuted={!myCameraStream().get('isAudioEnabled')}
              videoMuted={!myCameraStream().get('isVideoEnabled')}
              // helps with responsiveness - e.g. hide self on mobile
              className="ex3d-video--self"
            >
              <VideoStream autoStart={true} containerClassName="max-w-l" controlsClassName="hidden" />
            </ParticipantVideo>
          )}
          {remoteConnections &&
            Object.values(remoteConnections)
              .sort((remote) => (remote.isActiveSpeaker || remote.lastActiveSpeaker ? -1 : 0))
              .map(
                (remote) =>
                  // makes sure stream exists and it's a MediaStream
                  remote?.stream instanceof MediaStream && (
                    <ParticipantVideo
                      key={remote.stream.id}
                      audioMuted={!!remote.audioMuted}
                      videoMuted={!!remote.videoMuted}
                      className={remote.isActiveSpeaker ? 'ex3d-video--active-speaker' : 'ex3d-video--inactive-speaker'}
                    >
                      <Video
                        stream={remote.stream}
                        audioMuted={remote.audioMuted}
                        videoClassName="size-full object-cover"
                      />
                    </ParticipantVideo>
                  )
              )}
        </div>
      </div>
    )
  );
};

export default MultiVoipInternal;
